import * as React from 'react';
import Login from './landingpage/login';
import Imager from './images/imager.jpg';
import Menu from './menu';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import FilterListIcon from '@mui/icons-material/FilterList';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import PrintButton from './printbutton';
import AvatarGroup from '@mui/material/AvatarGroup';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Close from '@mui/icons-material/Close';
import { Offline, Online } from "react-detect-offline";
import Snack from './snack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import SchoolIcon from '@mui/icons-material/School';
import MaleIcon from '@mui/icons-material/Male';
import FemaleIcon from '@mui/icons-material/Female';
import ClassIcon from '@mui/icons-material/Class';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Studentchart1 from './chart/studentchart1';
import Studentchart2 from './chart/studentchart2';
import Studentchart3 from './chart/studentchart3';
import Activestaff from './chart/staff/activestaff';
import Position from './chart/staff/position';
import Demography from './chart/staff/demography';
import DatePicker from 'react-date-picker';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { admin } from './redux/admin';
import { getchat } from './redux/chat';
import { schooldetails } from './redux/schooldetails';
import { announcement_ } from './redux/announcement';
import { loin, logout, updatestudentdata, getdata } from './redux/students';
import { updateteacherdata, getdatateacher } from './redux/teachers';
import { getdata_ } from './redux/class';
import { capitalize } from '@mui/material';
import axiosInstance from './utils/axios';
import { getCurrencySymbolFromSchool } from './utils/currencyFormatter';
import { getActiveTerm, getActiveTermName } from './utils/termUtils';
import { mediaUrl, getSchoolLogoUrl, getStudentThumbnailUrl, getStudentFullImageUrl } from './utils/mediaUrls';
import {
    hasFinanceFullStudentAccess,
    hasSchoolWideStudentListAccess,
    hasCanteenCollectorAccess,
} from './utils/financeStaffRoles';
import {

    isPaymentCancelled,
    isPaymentPendingCancellation,
    isPaymentCountedInTotals,
} from './utils/schoolFeePayments';

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
}
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

/** Classify a school fee payment row for dashboard totals (matches tableschoolfees / Paystack payloads). */
function categorizeDashboardFeePaymentRow(row) {
    if (row == null) return "cash";
    const pm = row.paymentMethod != null ? String(row.paymentMethod).trim().toLowerCase() : "";
    if (pm === "online") return "online";
    const des = row.des != null ? String(row.des).trim().toLowerCase() : "";
    const description = row.description != null ? String(row.description).trim().toLowerCase() : "";
    if (des === "discount" || description === "discount") return "discount";
    return "cash";
}

function addPaymentToDashboardBreakdown(acc, row) {
    if (row == null || row.amountpaid == null || row.amountpaid === "") return;
    const amt = parseFloat(row.amountpaid) || 0;
    if (isPaymentCancelled(row)) {
        acc.cancelled += amt;
        return;
    }
    const cat = categorizeDashboardFeePaymentRow(row);
    if (isPaymentPendingCancellation(row)) {
        acc.pendingCancellation += amt;
    }
    if (cat === "online") acc.online += amt;
    else if (cat === "discount") acc.discount += amt;
    else acc.cash += amt;
}

function computeFeePaymentBreakdown(students, mainterm) {
    const acc = { cash: 0, discount: 0, online: 0, cancelled: 0, pendingCancellation: 0 };
    if (!students || !Array.isArray(students)) {
        return { ...acc, total: 0 };
    }
    const termActive = mainterm && mainterm !== "none";
    for (let si = 0; si < students.length; si++) {
        const student = students[si];
        if (!student || !student.finance || !Array.isArray(student.finance) || student.finance.length === 0) {
            continue;
        }
        let foundMatchingTermBucket = false;
        if (termActive) {
            for (let fi = 0; fi < student.finance.length; fi++) {
                const fin = student.finance[fi];
                if (!fin || fin.term !== mainterm || !Array.isArray(fin.payment)) continue;
                foundMatchingTermBucket = true;
                for (let pi = 0; pi < fin.payment.length; pi++) {
                    addPaymentToDashboardBreakdown(acc, fin.payment[pi]);
                }
            }
        }
        if (!foundMatchingTermBucket) {
            const fin = student.finance[student.finance.length - 1];
            if (!fin || !Array.isArray(fin.payment)) continue;
            for (let pi = 0; pi < fin.payment.length; pi++) {
                addPaymentToDashboardBreakdown(acc, fin.payment[pi]);
            }
        }
    }
    const total = acc.cash + acc.discount + acc.online;
    return { ...acc, total };
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function App({ setLoader }) {
    const [term, setterm] = React.useState("All");
    const dispatch = useDispatch();
    const [opensnack, setOpensnack] = React.useState(false);
    const theme = useTheme();
    const [value, setValue] = React.useState(0);
    const [preload, setpreload] = React.useState(true);
    const [openview, setOpenview] = React.useState(!true);
    const [chosen, setchosen] = React.useState([]);
    const [message, setmessage] = React.useState("");
    const [stated, setstated] = React.useState("");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const admin = useSelector((state) => state.admin);
    const hideDashboardStaffFinance = hasCanteenCollectorAccess(admin);
    const showDashboardFinanceTab =
        (hasFinanceFullStudentAccess(admin) || admin.smsID !== undefined) &&
        !hideDashboardStaffFinance;
    React.useEffect(() => {
        if (hideDashboardStaffFinance && value !== 0) {
            setValue(0);
        }
    }, [hideDashboardStaffFinance, value]);
    const schooldetails_ = useSelector((state) => state.schooldetails)[0];
    const announcement = useSelector((state) => state.announcement_);
    const dt = new Date();
    const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    const day = dt.getUTCDate();
    const month = String(dt.getMonth() + 1).padStart(2, '0');
    const year = dt.getFullYear();
    const date = year + "-" + month + "-" + day;
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const formatYmdDashboardDate = (dateVal) => {
        if (dateVal == null || dateVal === "") return "—";
        const raw = String(dateVal).trim();
        if (!raw) return "—";
        const ymd = raw.includes("T") ? raw.split("T")[0] : raw;
        const parts = ymd.split("-");
        if (parts.length < 3) return raw;
        const mi = parseInt(parts[1], 10) - 1;
        if (!Number.isFinite(mi) || !months[mi]) return raw;
        return `${months[mi]} ${parts[2]}, ${parts[0]}`;
    };
    const [dated_, setdated__] = React.useState(date);
    const handleChangeIndex = (index) => {
        setValue(index);
    };
    var da = [2, 3, 4, 5, 6, 7, 8];
    const stud = useSelector((state) => state.students);
    
    // Get currency symbol from school details
    const schooldetailsArray = useSelector((state) => state.schooldetails) || [];
    const currencySymbol = getCurrencySymbolFromSchool(schooldetailsArray);

    const schoolWideStudentList = hasSchoolWideStudentListAccess(admin);
    const students = schoolWideStudentList
        ? stud
        : admin.class_===undefined
            ? stud
            : (admin.class_ && admin.class_.length!==0)
                ? stud.filter(bug=>admin.class_[0].includes(bug.class_))
                : stud.filter(bug=>bug.class_===admin.positiondescription_);
    const classerRaw = useSelector((state) => state.class)
    const classer = React.useMemo(() => {
        if (!classerRaw || !Array.isArray(classerRaw)) return [];
        if (classerRaw.length === 1 && Array.isArray(classerRaw[0])) return classerRaw[0];
        return classerRaw;
    }, [classerRaw])
    var Class_ = schoolWideStudentList
        ? classer
        : admin.class_===undefined
            ? classer
            : (admin.class_ && admin.class_.length!==0)
                ? classer.filter(bug=>admin.class_[0].includes(bug.classname))
                : classer.filter(bug=>bug.classname === admin.positiondescription_);
    // var Class_ = useSelector((state) => state.class)

    const teachers = useSelector((state) => state.teachers);
    var classlist = [];
    var classdata = [];
    const handleClicksnack = () => {
        setOpensnack(true);
    };
    const handleClosesnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpensnack(false);
    };
    const handleClickOpenview = (data) => {
        setchosen(data);
        setOpenview(true);
    };
    const handleCloseview = () => {
        setOpenview(false);
    };
    for (var i in (Class_ || [])) {
        var data_ = (Class_ && Class_[i]) ? students.filter(bug => bug.class_ === Class_[i].classname).length : 0;
        classdata.push(data_);
    }
    for (var j in (Class_ || [])) {
        classlist.push(Class_[j].classname);
    }
    const schooldata = async () => {
        await axios.post("https://servermain.sisrevolution.com/api/schools/getschooldata/", {
            schoolID: admin.schoolID
        }).then(res => {
            if (res.status === 200) {
                dispatch(schooldetails({
                    data: res.data
                }));
                dispatch(getchat({
                    data: res.data[0].chat
                }));
            }
        });
    };
    const gettingdatat = async () => {
        await axios.post("https://servermain.sisrevolution.com/api/teachers/getworkersdata/", {
            status: "Active",
            schoolID: admin.schoolID
        }).then(res => {
            if (res.status === 200) {
                dispatch(getdatateacher({
                    data: res.data
                }));
            }
        });
    };
    const gettingdata_ = async () => {
        await axios.post("https://servermain.sisrevolution.com/api/class/getclassdata/", {
            status: "Active",
            schoolID: admin.schoolID
        }).then(res => {
            if (res.status === 200) {
                dispatch(getdata_({
                    data: res.data
                }));
            }
        });
    };
    const gettingdata = async () => {
        setLoader(true);
        try {
            const response = await axiosInstance.post("/api/students/getstudentdata/", {
                status: "Active",
                schoolID: admin.schoolID
            });
            
            if (response.status === 200) {
                    dispatch(getdata({
                    data: response.data
                    }));
                }
        } catch (err) {
            handleClicksnack();
            setmessage(err.response?.data?.message || "Network Error....");
            setstated("error");
        } finally {
            setLoader(false);
        }
    };
    const announcementdata = async () => {
        try {
            const response = await axiosInstance.post("/api/announcement/getannouncement/", {
            schoolID: admin.schoolID
            });
            
            if (response.status === 200) {
                dispatch(announcement_({
                    announcement: response.data.filter(bug => bug.to === undefined || bug.to === "All")
                }));
            }
        } catch (err) {
            console.error('Error fetching announcements:', err);
        }
    };
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([
                    // schooldata(),
                    // gettingdata(),
                    // gettingdata_(),
                    // gettingdatat(),
                    // announcementdata()
                ]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        
        fetchData();
    }, []); // Empty dependency array means this runs once on mount
    const mainterm =
        schooldetails_
            ? (getActiveTerm(schooldetails_) != null ? getActiveTerm(schooldetails_) : "none")
            : "none";

    const sumPaymentsOnFinanceRow = (fin) => {
        let sub = 0;
        if (!fin || !Array.isArray(fin.payment)) return sub;
        for (let pi = 0; pi < fin.payment.length; pi++) {
            const row = fin.payment[pi];
            if (row != null && row.amountpaid != null && row.amountpaid !== "" && isPaymentCountedInTotals(row)) {
                sub += parseFloat(row.amountpaid) || 0;
            }
        }
        return sub;
    };
    const fullpayment = () => {
        var total = 0;
        if (!students || !Array.isArray(students)) return total;
        
        var data = students.filter(bug => {
            // Check if finance exists and is an array with at least one element
            if (!bug.finance || !Array.isArray(bug.finance) || bug.finance.length === 0) {
                return false;
            }
            
            const latestFinance = bug.finance[bug.finance.length - 1];
            if (!latestFinance || !latestFinance.payment || !Array.isArray(latestFinance.payment) || latestFinance.payment.length === 0) {
                return false;
            }
            
            const lastPayment = latestFinance.payment[latestFinance.payment.length - 1];
            return lastPayment && lastPayment.balance === 0;
        });
        
        if (data.length !== 0) {
            for (var i in data) {
                const latestFinance = data[i].finance[data[i].finance.length - 1];
                if (latestFinance) {
                    total += (parseFloat(latestFinance.totalfees) || 0) + (parseFloat(latestFinance.Arrears) || 0);
                }
            }
        }
        return total;
    };
    const fullpaymentstud = () => {
        if (!students || !Array.isArray(students)) return 0;
        
        var data = students.filter(bug => {
            // Check if finance exists and is an array with at least one element
            if (!bug.finance || !Array.isArray(bug.finance) || bug.finance.length === 0) {
                return false;
            }
            
            const latestFinance = bug.finance[bug.finance.length - 1];
            if (!latestFinance || !latestFinance.payment || !Array.isArray(latestFinance.payment) || latestFinance.payment.length === 0) {
                return false;
            }
            
            const lastPayment = latestFinance.payment[latestFinance.payment.length - 1];
            const balance = parseFloat(lastPayment.balance) || 0;
            const arrears = parseFloat(latestFinance.Arrears) || 0;
            
            return lastPayment && balance === 0 && arrears === 0;
        });
        
        return data.length;
    };
    const calcoutstanding = () => {
        var total = 0;
        if (!students || !Array.isArray(students)) return total;
        
        for (var i in students) {
            if (!students[i]) continue;
            
            const studentFinance = students[i].finance;
            const hasFinance = studentFinance && Array.isArray(studentFinance) && studentFinance.length !== 0;
            
            if (hasFinance && studentFinance[studentFinance.length - 1].term === mainterm) {
                // Use balance from matching term
                const balance = parseFloat(studentFinance[studentFinance.length - 1].balance) || 0;
                total += parseFloat(balance.toFixed(2));
            } else if (hasFinance) {
                // Use totalfees, balance, and arrears
                const latestFinance = studentFinance[studentFinance.length - 1];
                let classFees = 0;
                
                if (Class_ && Array.isArray(Class_)) {
                    const classMatch = Class_.filter(bug => bug.classname === students[i].class_);
                    if (classMatch.length !== 0 && classMatch[0].classfees) {
                        classFees = parseFloat(classMatch[0].classfees) || 0;
                    }
                }
                
                const totalFees = parseFloat(latestFinance.totalfees) || 0;
                const balance = parseFloat(latestFinance.balance) || 0;
                const arrears = parseFloat(latestFinance.Arrears) || 0;
                
                if (totalFees !== null && totalFees !== undefined) {
                    total += parseFloat((classFees + balance + arrears).toFixed(2));
                } else {
                    total += parseFloat(classFees.toFixed(2));
                }
            } else {
                // No finance data, use class fees
                if (Class_ && Array.isArray(Class_)) {
                    const classMatch = Class_.filter(bug => bug.classname === students[i].class_);
                    if (classMatch.length !== 0 && classMatch[0].classfees) {
                        const classFees = parseFloat(classMatch[0].classfees) || 0;
                        total += parseFloat(classFees.toFixed(2));
                    }
                }
            }
        }
        return total;
    };
    const totalamountpaid = (input) => {
        var result = 0;
        for (var i in input) {
            if (!isPaymentCountedInTotals(input[i])) continue;
            result += parseFloat(input[i].amountpaid) || 0;
        }
        return result;
    };
    const totalFeesCollectedMainTerm = () => computeFeePaymentBreakdown(students, mainterm).total;
    const studentsWithMainTermPaymentsCount = () => {
        if (!students || !Array.isArray(students)) return 0;
        const termActive = mainterm && mainterm !== "none";
        let count = 0;
        for (let si = 0; si < students.length; si++) {
            const student = students[si];
            if (!student || !student.finance || !Array.isArray(student.finance) || student.finance.length === 0) {
                continue;
            }
            let foundMatchingTermBucket = false;
            let bucketTotal = 0;
            if (termActive) {
                for (let fi = 0; fi < student.finance.length; fi++) {
                    const fin = student.finance[fi];
                    if (fin && fin.term === mainterm) {
                        foundMatchingTermBucket = true;
                        bucketTotal += sumPaymentsOnFinanceRow(fin);
                    }
                }
            }
            if (!foundMatchingTermBucket) {
                const latest = student.finance[student.finance.length - 1];
                bucketTotal = sumPaymentsOnFinanceRow(latest);
            }
            if (bucketTotal > 0) count += 1;
        }
        return count;
    };
    const calcdue = () => {
        var total = 0;
        var rows = students;
        if (!Class_ || !Array.isArray(Class_) || Class_.length === 0) return total;
        for (var i in rows) {
            if (!rows[i]) continue;

            const matched = Class_.find(bug => bug && bug.classname === rows[i].class_);
            if (!matched) continue;
            const baseFee = parseFloat(matched.classfees) || 0;

            if (rows[i].finance && rows[i].finance.length !== 0) {
                const lastFinance = rows[i].finance[rows[i].finance.length - 1];
                if (!lastFinance) continue;
                if (lastFinance.Arrears !== null && lastFinance.term === mainterm) {
                    total += parseFloat((parseFloat(totalamountpaid(lastFinance.payment)) + parseFloat(lastFinance.balance ? lastFinance.balance : 0)).toFixed(2));
                } else {
                    total += parseFloat((baseFee + parseFloat(lastFinance.Arrears || 0) + parseFloat(lastFinance.balance ? lastFinance.balance : 0)).toFixed(2));
                }
            } else {
                total += parseFloat(baseFee.toFixed(2));
            }
        }
        return total;
    };
    const totalpaid = () => {
        var total = 0;
        if (!students || !Array.isArray(students)) return total;
        
        for (var i in students) {
            if (students[i].finance && Array.isArray(students[i].finance) && students[i].finance.length !== 0) {
                const latestFinance = students[i].finance[students[i].finance.length - 1];
                if (latestFinance) {
                    total += (parseFloat(latestFinance.totalfees) || 0) + (parseFloat(latestFinance.Arrears) || 0);
                }
            } else {
                if (Class_ && Array.isArray(Class_)) {
                    const classMatch = Class_.filter(bug => bug.classname === students[i].class_);
                    if (classMatch.length !== 0 && classMatch[0].classfees) {
                        total += parseFloat(classMatch[0].classfees) || 0;
                    }
                }
            }
        }
        return total;
    };
    const totalpaidstud = () => {
        if (!students || !Array.isArray(students)) return 0;
        
        var data = students.filter(bug => {
            // Check if finance exists and is an array with at least one element
            if (!bug.finance || !Array.isArray(bug.finance) || bug.finance.length === 0) {
                return false;
            }
            
            const latestFinance = bug.finance[bug.finance.length - 1];
            return latestFinance && latestFinance.payment && Array.isArray(latestFinance.payment) && latestFinance.payment.length !== 0;
        });
        
        return data.length;
    };
    const fullowing = (students_) => {
        var total = 0;
        if (!students_ || !Array.isArray(students_)) return total;
        
        var data = students_.filter(bug => {
            // Check if finance exists and is an array with at least one element
            if (!bug.finance || !Array.isArray(bug.finance) || bug.finance.length === 0) {
                return false;
            }
            
            const latestFinance = bug.finance[bug.finance.length - 1];
            if (!latestFinance || !latestFinance.payment || !Array.isArray(latestFinance.payment) || latestFinance.payment.length === 0) {
                return false;
            }
            
            const lastPayment = latestFinance.payment[latestFinance.payment.length - 1];
            return lastPayment && lastPayment.balance !== 0;
        });
        
        var data2 = students_.filter(bug => {
            return !bug.finance || !Array.isArray(bug.finance) || bug.finance.length === 0;
        });
        
        if (data.length !== 0) {
            for (var i in data) {
                const latestFinance = data[i].finance[data[i].finance.length - 1];
                if (latestFinance && latestFinance.payment && Array.isArray(latestFinance.payment) && latestFinance.payment.length > 0) {
                    const lastPayment = latestFinance.payment[latestFinance.payment.length - 1];
                    if (lastPayment && lastPayment.balance) {
                        total += parseFloat(lastPayment.balance) || 0;
                    }
                }
            }
        }
        if (data2.length !== 0) {
            for (var i in data2) {
                if (Class_ && Array.isArray(Class_)) {
                    const classMatch = Class_.filter(bug => bug.classname === data2[i].class_);
                    if (classMatch.length !== 0 && classMatch[0].classfees) {
                        total += parseFloat(classMatch[0].classfees) || 0;
                    }
                }
            }
        }
        return total;
    };
    const owingstudents = (students_) => {
        var total = 0;
        if (!students_ || !Array.isArray(students_)) return total;
        
        var data = students_.filter(bug => {
            // Check if finance exists and is an array with at least one element
            if (!bug.finance || !Array.isArray(bug.finance) || bug.finance.length === 0) {
                return false;
            }
            
            const latestFinance = bug.finance[bug.finance.length - 1];
            if (!latestFinance || !latestFinance.payment || !Array.isArray(latestFinance.payment) || latestFinance.payment.length === 0) {
                return false;
            }
            
            const lastPayment = latestFinance.payment[latestFinance.payment.length - 1];
            return lastPayment && lastPayment.balance !== 0;
        });
        
        var data2 = students_.filter(bug => {
            return !bug.finance || !Array.isArray(bug.finance) || bug.finance.length === 0;
        });
        
        if (data.length !== 0) {
            total += data.length;
        }
        if (data2.length !== 0) {
            total += data2.length;
        }
        return total;
    };
    const feesdata = () => {
        var total = [];
        for (var i in classlist) {
            total.push(fullowing(students.filter(bug => bug.class_ === classlist[i])));
        }
        return total;
    };
    const feesdatabynumber = () => {
        var total = [];
        for (var i in classlist) {
            total.push(owingstudents(students.filter(bug => bug.class_ === classlist[i])));
        }
        return total;
    };
    const fullowingstud = () => {
        if (!students || !Array.isArray(students)) return 0;
        
        var data = students.filter(bug => {
            // Check if finance exists and is an array with at least one element
            if (!bug.finance || !Array.isArray(bug.finance) || bug.finance.length === 0) {
                return false;
            }
            
            const latestFinance = bug.finance[bug.finance.length - 1];
            if (!latestFinance || !latestFinance.payment || !Array.isArray(latestFinance.payment) || latestFinance.payment.length === 0) {
                return false;
            }
            
            const lastPayment = latestFinance.payment[latestFinance.payment.length - 1];
            const balance = parseFloat(latestFinance.balance) || 0;
            const paymentBalance = parseFloat(lastPayment.balance) || 0;
            
            return lastPayment && paymentBalance === balance;
        });
        
        return data.length;
    };
    const classattendance = (list) => {
        if (schooldetails_ !== undefined) {
            var data = 0;
            const currentTermKey = getActiveTermName(schooldetails_) || getActiveTerm(schooldetails_);
            var useing = students.filter(bug => bug.class_ === list.classname && bug.attendance.length !== 0);
            for (var i in useing) {
                var li = currentTermKey && useing[i].attendance[currentTermKey] !== undefined && useing[i].attendance[currentTermKey];
                for (var k in li) {
                    if (li[k].date === dated_ && li[k].attendance === "present") {
                        data += 1;
                    }
                }
            }
            return data;
        }
    };
    const totalattendance = () => {
        var data = 0;
        var useing = students ? students.filter(bug => bug.attendance.length !== 0) : [];
        const currentTermKey = getActiveTermName(schooldetails_) || getActiveTerm(schooldetails_);
        for (var i in useing) {
            console.log(schooldetails_);
            if (schooldetails_ !== undefined) {
                var li = currentTermKey && useing[i].attendance[currentTermKey] !== undefined && useing[i].attendance[currentTermKey];
                for (var k in li) {
                    if (li[k].date === dated_ && li[k].attendance === "present") {
                        data += 1;
                    }
                }
            }
        }
        return data;
    };
    const dailycharges = (list) => {
        if (schooldetails_ !== undefined) {
            var data = 0;
            const currentTermKey = getActiveTermName(schooldetails_) || getActiveTerm(schooldetails_);
            var useing = students.filter(bug => bug.class_ === list.classname && bug.attendance.length !== 0);
            for (var i in useing) {
                var li = currentTermKey && useing[i].attendance[currentTermKey] !== undefined && useing[i].attendance[currentTermKey];
                for (var k in li) {
                    if (li[k].date === dated_ && li[k].attendance === "present") {
                        data += parseFloat(useing[i].dailyfee);
                    }
                }
            }
            return data;
        }
    };
    const totaldailycharges = () => {
        if (schooldetails_ !== undefined && schooldetails_.terms && schooldetails_.terms.length > 0) {
            var data = 0;
            var useing = students.filter(bug => bug.attendance && bug.attendance.length !== 0);
            const currentTerm = getActiveTermName(schooldetails_) || getActiveTerm(schooldetails_);
            for (var i in useing) {
                var li = currentTerm ? useing[i].attendance[currentTerm] : null;
                if (li) {
                for (var k in li) {
                    if (li[k].date === dated_ && li[k].attendance === "present") {
                            data += parseFloat(useing[i].dailyfee || 0);
                        }
                    }
                }
            }
            return data;
        }
        return 0;
    };
    const partialpayment = () => {
        var total = 0;
        if (!students || !Array.isArray(students)) return total;
        
        var data = students.filter(bug => {
            // Check if finance exists and is an array with at least one element
            if (!bug.finance || !Array.isArray(bug.finance) || bug.finance.length === 0) {
                return false;
            }
            
            const latestFinance = bug.finance[bug.finance.length - 1];
            if (!latestFinance || !latestFinance.payment || !Array.isArray(latestFinance.payment) || latestFinance.payment.length === 0) {
                return false;
            }
            
            const lastPayment = latestFinance.payment[latestFinance.payment.length - 1];
            return lastPayment && lastPayment.balance !== 0;
        });
        
        if (data.length !== 0) {
            for (var i in data) {
                const latestFinance = data[i].finance[data[i].finance.length - 1];
                if (latestFinance && latestFinance.payment && Array.isArray(latestFinance.payment)) {
                    for (var k in latestFinance.payment) {
                        const payment = latestFinance.payment[k];
                        if (payment && payment.amountpaid) {
                            total += parseFloat(payment.amountpaid) || 0;
                        }
                    }
                }
            }
        }
        return total;
    };
    const partialpaymentstud = () => {
        if (!students || !Array.isArray(students)) return 0;
        
        var data = students.filter(bug => {
            // Check if finance exists and is an array with at least one element
            if (!bug.finance || !Array.isArray(bug.finance) || bug.finance.length === 0) {
                return false;
            }
            
            const latestFinance = bug.finance[bug.finance.length - 1];
            if (!latestFinance) {
                return false;
            }
            
            const balance = parseFloat(latestFinance.balance) || 0;
            const totalFees = parseFloat(latestFinance.totalfees) || 0;
            
            return balance !== 0 && balance !== totalFees;
        });
        
        return data.length;
    };
    const dashboardFeeBreakdown = React.useMemo(
        () => computeFeePaymentBreakdown(students, mainterm),
        [students, mainterm]
    );
    return (
        <Box sx={{ bgcolor: 'background.paper', width: "100%", overflowX: "hidden" }}>
            <Snackbar open={opensnack} autoHideDuration={6000} onClose={handleClosesnack}>
                <Alert onClose={handleClosesnack} severity={stated} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
            <Dialog
                fullWidth
                maxWidth="sm"
                onClose={handleCloseview}
                aria-labelledby="customized-dialog-title"
                open={openview}
                sx={{
                    '& .MuiDialog-paper': {
                        width: { xs: '90%', sm: '70%', md: '50%' },
                        margin: { xs: 2, sm: 4 },
                    }
                }}
            >
                <DialogTitle id="customized-dialog-title">
                    <span style={{
                        fontSize: { xs: 16, sm: 18, md: 20 },
                        marginLeft: { xs: 10, sm: 20, md: 30 },
                        color: "grey"
                    }}>Announcement views</span>
                    <IconButton aria-label="" onClick={handleCloseview} sx={{ float: "right" }}>
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {chosen && chosen.map((list, index) =>
                        <List key={index} sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                            <ListItem alignItems="flex-start">
                                <ListItemAvatar>
                                    <Avatar alt={list.name} src={mediaUrl('thumbnail', list.image)} />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={list.name}
                                    secondary={
                                        <React.Fragment>
                                            <Typography
                                                sx={{ display: 'inline' }}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                            >
                                                {formatYmdDashboardDate(list.date)}
                                            </Typography>
                                            {" - " + list.time}
                                        </React.Fragment>
                                    }
                                />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                        </List>
                    )}
                </DialogContent>
                <DialogActions sx={{ textAlign: "center" }}></DialogActions>
            </Dialog>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            padding: { xs: '6px 12px', sm: '8px 16px' },
                        }
                    }}
                >
                    <Tab label="Students" {...a11yProps(0)} />
                    {!hideDashboardStaffFinance && <Tab label="Staff" {...a11yProps(1)} />}
                    {showDashboardFinanceTab && <Tab label="Finance" {...a11yProps(2)} />}
                </Tabs>
            </Box>
            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12} sm={6} md={3}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#3A27CE",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Box sx={{ textAlign: "right", width: "100%" }}>
                                    <IconButton sx={{
                                        mt: 1,
                                        mr: 1,
                                        bgcolor: "rgba(0,0,0,0.1)",
                                        '&:hover': { bgcolor: "rgba(0,0,0,0.2)" }
                                    }}>
                                        <SchoolIcon sx={{ color: "white", fontSize: { xs: 20, sm: 22, md: 25 } }} />
                                    </IconButton>
                                </Box>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 32, sm: 40, md: 47 },
                                    mt: -1,
                                    mb: 1
                                }}>
                                    {Intl.NumberFormat('en-US').format(students.length)}
                                </Typography>
                                <Typography component="small" align="center" sx={{
                                    color: "white",
                                    mb: 0.5,
                                    mt: -1,
                                    fontSize: { xs: 10, sm: 12, md: 14 }
                                }}>
                                    Total Number Of students
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#D10F3D",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Box sx={{ textAlign: "right", width: "100%" }}>
                                    <IconButton sx={{
                                        mt: 1,
                                        mr: 1,
                                        bgcolor: "rgba(0,0,0,0.1)",
                                        '&:hover': { bgcolor: "rgba(0,0,0,0.2)" }
                                    }}>
                                        <MaleIcon sx={{ color: "white", fontSize: { xs: 20, sm: 22, md: 25 } }} />
                                    </IconButton>
                                </Box>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 32, sm: 40, md: 47 },
                                    mt: -1,
                                    mb: 1
                                }}>
                                    {Intl.NumberFormat('en-US').format(students.filter(bug => bug.gender && (bug.gender).toLowerCase() === "male").length)}
                                </Typography>
                                <Typography component="small" align="center" sx={{
                                    color: "white",
                                    mb: 0.5,
                                    mt: -1,
                                    fontSize: { xs: 10, sm: 12, md: 14 }
                                }}>
                                    Number Of Male Students
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#13A518",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Box sx={{ textAlign: "right", width: "100%" }}>
                                    <IconButton sx={{
                                        mt: 1,
                                        mr: 1,
                                        bgcolor: "rgba(0,0,0,0.1)",
                                        '&:hover': { bgcolor: "rgba(0,0,0,0.2)" }
                                    }}>
                                        <FemaleIcon sx={{ color: "white", fontSize: { xs: 20, sm: 22, md: 25 } }} />
                                    </IconButton>
                                </Box>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 32, sm: 40, md: 47 },
                                    mt: -1,
                                    mb: 1
                                }}>
                                    {Intl.NumberFormat('en-US').format(students.filter(bug => bug.gender && (bug.gender).toLowerCase() === "female").length)}
                                    </Typography>
                                <Typography component="small" align="center" sx={{
                                    color: "white",
                                    mb: 0.5,
                                    mt: -1,
                                    fontSize: { xs: 10, sm: 12, md: 14 }
                                }}>
                                    Number Of Female students
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "orange",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Box sx={{ textAlign: "right", width: "100%" }}>
                                    <IconButton sx={{
                                        mt: 1,
                                        mr: 1,
                                        bgcolor: "rgba(0,0,0,0.1)",
                                        '&:hover': { bgcolor: "rgba(0,0,0,0.2)" }
                                    }}>
                                        <ClassIcon sx={{ color: "white", fontSize: { xs: 20, sm: 22, md: 25 } }} />
                                    </IconButton>
                                </Box>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 32, sm: 40, md: 47 },
                                    mt: -1,
                                    mb: 1
                                }}>
                                    {Intl.NumberFormat('en-US').format(Class_.length)}
                                </Typography>
                                <Typography component="small" align="center" sx={{
                                    color: "white",
                                    mb: 0.5,
                                    mt: -1,
                                    fontSize: { xs: 10, sm: 12, md: 14 }
                                }}>
                                    Number Of Classes
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box sx={{ my: { xs: 1, sm: 2 } }} />
                    <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12} md={9}>
                            <Box sx={{
                                p: { xs: 1, sm: 2 },
                                borderRadius: "10px",
                                minHeight: { xs: 250, sm: 350, md: 420 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                boxSizing: "border-box"
                            }}>
                                <Typography sx={{ fontWeight: "bold", fontSize: { xs: 14, sm: 16, md: 18 } }}>
                                    A Graphical Representation of the Number of Students in Each Class
                                </Typography>
                                <Studentchart1 data={classdata} categories={classlist} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 250, sm: 350, md: 420 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#e0eff9",
                                boxSizing: "border-box"
                            }}>
                                <Box sx={{ p: 1, textAlign: "center" }} align="left">
                                    <Typography sx={{ fontWeight: "bold", color: "#1976d2", fontSize: { xs: 14, sm: 16, md: 18 } }}>
                                        Class Attendance
                                    </Typography>
                                    <input
                                        type="date"
                                        value={dated_}
                                        onChange={(e) => setdated__(e.target.value)}
                                        style={{
                                            fontSize: "16px",
                                            color: "#1976d2",
                                            backgroundColor: "#e0eff9",
                                            border: "solid",
                                            borderWidth: "0.1px",
                                            borderColor: "lightgray",
                                            padding: "5px",
                                            margin: "5px",
                                            borderRadius: "5px",
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                    />
                                </Box>
                                <Divider />
                                <Typography variant="h1" align="center" sx={{
                                    m: 0.5,
                                    color: "#1976d2",
                                    fontSize: { xs: 24, sm: 32, md: 40 }
                                }}>
                                    {Intl.NumberFormat('en-US').format(totalattendance())}
                                </Typography>
                                <Typography sx={{
                                    mt: -2,
                                    fontSize: { xs: 10, sm: 11, md: 12 },
                                    color: "#1976d2",
                                    m: 0.5
                                }}>
                                    {formatYmdDashboardDate(dated_)}
                                </Typography>
                                <Divider />
                                <Box sx={{ pl: 0.5, pr: 0.5 }}>
                                    <Box sx={{
                                        maxHeight: { xs: 150, sm: 200, md: 255 },
                                        overflowY: "auto",
                                        scrollbarWidth: "thin"
                                    }}>
                                        <List sx={{ width: '100%', maxWidth: 360, m: 0, p: 0.5 }}>
                                            {Class_ && Class_.map((list, index) =>
                                                <Box key={index}>
                                                    <ListItem
                                                        sx={{ p: 0 }}
                                                        disableGutters
                                                        secondaryAction={
                                                            <Typography sx={{ fontWeight: "bold", fontSize: { xs: 12, sm: 14 } }}>
                                                                {Intl.NumberFormat('en-US').format(classattendance(list))}
                                                            </Typography>
                                                        }
                                                    >
                                                        <ListItemText
                                                            primary={list.classname}
                                                            secondary={
                                                                <Typography component="small" sx={{ fontSize: { xs: 10, sm: 12 } }}>
                                                                    {formatYmdDashboardDate(dated_)}
                                                                </Typography>
                                                            }
                                                        />
                                                    </ListItem>
                                                    <Divider />
                                                </Box>
                                            )}
                                        </List>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </TabPanel>
                {!hideDashboardStaffFinance && (
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#e9543c",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{
                                    mb: -1,
                                    color: "white",
                                    fontSize: { xs: 12, sm: 14, md: 16 }
                                }}>
                                    Total Number Of staff
                                </Typography>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 32, sm: 40, md: 45 }
                                }}>
                                    {teachers.length}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#27948f",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{
                                    mb: -1,
                                    color: "white",
                                    fontSize: { xs: 12, sm: 14, md: 16 }
                                }}>
                                    Number Of Teaching Staff
                                </Typography>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 32, sm: 40, md: 45 }
                                }}>
                                    {teachers.filter(bug => bug.position === "Teaching Staff").length}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#89358a",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{
                                    mb: -1,
                                    color: "white",
                                    fontSize: { xs: 12, sm: 14, md: 16 }
                                }}>
                                    Number Of nonteaching Staff
                                </Typography>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 32, sm: 40, md: 45 }
                                }}>
                                    {teachers.filter(bug => bug.position === "Non-Teaching Staff").length}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box sx={{ my: { xs: 1, sm: 2 } }} />
                    <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box sx={{
                                p: 1,
                                borderRadius: "10px",
                                minHeight: { xs: 200, sm: 250, md: 300 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{ fontWeight: "bold", fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                    Number of Non-Teaching staff against Teacing staff
                                </Typography>
                                <Activestaff active={teachers.filter(bug => bug.position === "Teaching Staff").length} inactive={teachers.filter(bug => bug.position !== "Teaching Staff").length} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box sx={{
                                p: 1,
                                borderRadius: "10px",
                                minHeight: { xs: 200, sm: 250, md: 300 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{ fontWeight: "bold", fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                    Number of Male staff against Female staff
                                </Typography>
                                <Demography male={teachers.filter(bug => bug.gender === "Male").length} female={teachers.filter(bug => bug.gender === "Female").length} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 200, sm: 250, md: 300 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{ color: "gray", width: "100%", zIndex: 9, m: 0.5, fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                    Notice board
                                </Typography>
                                <Divider />
                                <Box sx={{ maxHeight: { xs: 150, sm: 200, md: 260 }, overflowY: "auto", scrollbarWidth: "thin" }}>
                                    {announcement && announcement.map((list, index) =>
                                        <Box key={index} align="left" sx={{ m: 1 }}>
                                            <Box sx={{
                                                border: "solid",
                                                borderWidth: "0.1px",
                                                borderColor: "lightgrey",
                                                borderRadius: "10px",
                                                p: 0.5,
                                                mt: 1
                                            }}>
                                                <Typography sx={{ m: 0.5, fontSize: { xs: 12, sm: 14 } }}>
                                                    {capitalize(list.subject)} <br />
                                                    <Typography component="small" sx={{ fontSize: { xs: 10, sm: 12 } }}>
                                                        {formatYmdDashboardDate(list.date)}
                                                    </Typography>
                                                </Typography>
                                                <Typography sx={{ color: "grey", fontSize: { xs: 11, sm: 13 }, textOverflow: 'inherit' }}>
                                                    {list.message}
                                                </Typography>
                                                <Grid container>
                                                    <Grid item xs={12}>
                                                        <AvatarGroup max={2}>
                                                            {list.views.length !== 0 ?
                                                                list.views && list.views.map((lister, idexer) =>
                                                                    <Avatar key={idexer} alt="Remy Sharp" src={mediaUrl('thumbnail', list.views[0].image)} onClick={() => handleClickOpenview(list.views)} />
                                                                ) :
                                                                <Typography align="right" sx={{ fontSize: { xs: 10, sm: 12 } }}>No Viewer</Typography>
                                                            }
                                                        </AvatarGroup>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </TabPanel>
                )}
                {showDashboardFinanceTab && (
                <TabPanel value={value} index={2} dir={theme.direction}>
                    <Box sx={{ minHeight: { xs: 500, sm: 700, md: 900 } }}>
                        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{
                                    borderRadius: "10px",
                                    minHeight: { xs: 120, sm: 140, md: 150 },
                                    border: "solid",
                                    borderColor: "lightgray",
                                    borderWidth: "0.01px",
                                    width: "100%",
                                    m: { xs: 0.5, sm: 1 },
                                    bgcolor: "#e9543c",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    boxSizing: "border-box"
                                }}>
                                    <Typography align="center" sx={{ color: "white", fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                        Total Fees Due
                                    </Typography>
                                    <Typography variant="h1" align="center" sx={{
                                        color: "white",
                                        fontSize: { xs: 24, sm: 28, md: 32 },
                                        m: -1
                                    }}>
                                        <span style={{ fontSize: "20px" }}>{currencySymbol} </span>{Intl.NumberFormat('en-US').format(parseFloat(calcdue()).toFixed(2))}
                                    </Typography>
                                    <Typography sx={{ color: "white", fontSize: { xs: 10, sm: 12, md: 14 } }}>
                                        {students.length} student(s)
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{
                                    borderRadius: "10px",
                                    minHeight: { xs: 120, sm: 140, md: 150 },
                                    border: "solid",
                                    borderColor: "lightgray",
                                    borderWidth: "0.01px",
                                    width: "100%",
                                    m: { xs: 0.5, sm: 1 },
                                    bgcolor: "#27948f",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    boxSizing: "border-box"
                                }}>
                                    <Typography align="center" sx={{ color: "white", fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                        Partial Payment
                                    </Typography>
                                    <Typography variant="h1" align="center" sx={{
                                        color: "white",
                                        fontSize: { xs: 24, sm: 28, md: 32 },
                                        m: -1
                                    }}>
                                        <span style={{ fontSize: "20px" }}>{currencySymbol} </span>{Intl.NumberFormat('en-US').format(parseFloat(partialpayment()).toFixed(2))}
                                    </Typography>
                                    <Typography sx={{ color: "white", fontSize: { xs: 10, sm: 12, md: 14 } }}>
                                        {partialpaymentstud()} student(s)
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{
                                    borderRadius: "10px",
                                    minHeight: { xs: 120, sm: 140, md: 150 },
                                    border: "solid",
                                    borderColor: "lightgray",
                                    borderWidth: "0.01px",
                                    width: "100%",
                                    m: { xs: 0.5, sm: 1 },
                                    bgcolor: "#89358a",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    boxSizing: "border-box"
                                }}>
                                    <Typography align="center" sx={{ color: "white", fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                        Outstanding Dept
                                    </Typography>
                                    <Typography variant="h1" align="center" sx={{
                                        color: "white",
                                        fontSize: { xs: 24, sm: 28, md: 32 },
                                        m: -1
                                    }}>
                                        <span style={{ fontSize: "20px" }}>{currencySymbol} </span>{Intl.NumberFormat('en-US').format(parseFloat(calcoutstanding()).toFixed(2))}
                                    </Typography>
                                    <Typography sx={{ color: "white", fontSize: { xs: 10, sm: 12, md: 14 } }}>
                                        {owingstudents(students)} student(s)
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{
                                    borderRadius: "10px",
                                    minHeight: { xs: 175, sm: 195, md: 205 },
                                    border: "solid",
                                    borderColor: "lightgray",
                                    borderWidth: "0.01px",
                                    width: "100%",
                                    m: { xs: 0.5, sm: 1 },
                                    bgcolor: "#31a0be",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    boxSizing: "border-box",
                                    py: 1,
                                }}>
                                    <Typography align="center" sx={{ color: "white", fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                        Total Paid
                                    </Typography>
                                    <Typography variant="h1" align="center" sx={{
                                        color: "white",
                                        fontSize: { xs: 22, sm: 26, md: 30 },
                                        m: -0.5,
                                    }}>
                                        <span style={{ fontSize: "18px" }}>{currencySymbol} </span>{Intl.NumberFormat('en-US').format(parseFloat(dashboardFeeBreakdown.total.toFixed(2)))}
                                    </Typography>
                                    <Box sx={{ width: "100%", px: 1.5, mt: 0.5 }}>
                                        <Typography sx={{ color: "rgba(255,255,255,0.95)", fontSize: { xs: 10, sm: 11 }, lineHeight: 1.35 }}>
                                            Cash (in person): {currencySymbol}{Intl.NumberFormat('en-US').format(parseFloat(dashboardFeeBreakdown.cash.toFixed(2)))}
                                        </Typography>
                                        <Typography sx={{ color: "rgba(255,255,255,0.95)", fontSize: { xs: 10, sm: 11 }, lineHeight: 1.35 }}>
                                            Discount: {currencySymbol}{Intl.NumberFormat('en-US').format(parseFloat(dashboardFeeBreakdown.discount.toFixed(2)))}
                                        </Typography>
                                        <Typography sx={{ color: "rgba(255,255,255,0.95)", fontSize: { xs: 10, sm: 11 }, lineHeight: 1.35 }}>
                                            Online: {currencySymbol}{Intl.NumberFormat('en-US').format(parseFloat(dashboardFeeBreakdown.online.toFixed(2)))}
                                        </Typography>
                                        {dashboardFeeBreakdown.cancelled > 0 && (
                                        <Typography sx={{ color: "rgba(255,255,255,0.85)", fontSize: { xs: 10, sm: 11 }, lineHeight: 1.35 }}>
                                            Cancelled (excluded): {currencySymbol}{Intl.NumberFormat('en-US').format(parseFloat(dashboardFeeBreakdown.cancelled.toFixed(2)))}
                                        </Typography>
                                        )}
                                        {dashboardFeeBreakdown.pendingCancellation > 0 && (
                                        <Typography sx={{ color: "rgba(255,255,255,0.85)", fontSize: { xs: 10, sm: 11 }, lineHeight: 1.35 }}>
                                            Pending cancellation: {currencySymbol}{Intl.NumberFormat('en-US').format(parseFloat(dashboardFeeBreakdown.pendingCancellation.toFixed(2)))}
                                        </Typography>
                                        )}
                                    </Box>
                                    <Typography sx={{ color: "white", fontSize: { xs: 10, sm: 12, md: 14 }, mt: 0.5 }}>
                                        {studentsWithMainTermPaymentsCount()} student(s)
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        <Box sx={{ my: { xs: 1, sm: 2 } }} />
                        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={12} md={9}>
                                <Box sx={{
                                    borderRadius: "10px",
                                    minHeight: { xs: 200, sm: 250, md: 290 },
                                    border: "solid",
                                    borderColor: "lightgray",
                                    borderWidth: "0.01px",
                                    width: "100%",
                                    m: { xs: 0.5, sm: 1 },
                                    boxSizing: "border-box"
                                }}>
                                    <Typography align="center" sx={{
                                        mb: -1,
                                        color: "black",
                                        fontWeight: "bold",
                                        fontSize: { xs: 12, sm: 14, md: 16 }
                                    }}>
                                        A Graphical Representation of Class Against Amount Owing by Students
                                    </Typography>
                                    <Studentchart3 classes={classlist} data={feesdata()} />
                                </Box>
                                <Box sx={{ my: { xs: 1, sm: 2 } }} />
                                <Box sx={{
                                    borderRadius: "10px",
                                    minHeight: { xs: 200, sm: 250, md: 290 },
                                    border: "solid",
                                    borderColor: "lightgray",
                                    borderWidth: "0.01px",
                                    width: "100%",
                                    m: { xs: 0.5, sm: 1 },
                                    boxSizing: "border-box"
                                }}>
                                    <Typography align="center" sx={{
                                        mb: -1,
                                        color: "black",
                                        fontWeight: "bold",
                                        fontSize: { xs: 12, sm: 14, md: 16 }
                                    }}>
                                        Class vs Number of Students Owing
                                    </Typography>
                                    <Studentchart3 classes={classlist} data={feesdatabynumber()} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Box sx={{
                                    borderRadius: "10px",
                                    minHeight: { xs: 250, sm: 350, md: 420 },
                                    border: "solid",
                                    borderColor: "lightgray",
                                    borderWidth: "0.01px",
                                    width: "100%",
                                    m: { xs: 0.5, sm: 1 },
                                    bgcolor: "#e0eff9",
                                    boxSizing: "border-box"
                                }}>
                                    <Box sx={{ p: 1, textAlign: "center" }} align="left">
                                        <Typography sx={{ fontWeight: "bold", color: "#1976d2", fontSize: { xs: 14, sm: 16, md: 18 } }}>
                                            Daily Charges
                                        </Typography>
                                        <input
                                            type="date"
                                            value={dated_}
                                            onChange={(e) => setdated__(e.target.value)}
                                            style={{
                                                fontSize: "16px",
                                                color: "#1976d2",
                                                backgroundColor: "#e0eff9",
                                                border: "solid",
                                                borderWidth: "0.1px",
                                                borderColor: "lightgray",
                                                padding: "5px",
                                                margin: "5px",
                                                borderRadius: "5px",
                                                width: "100%",
                                                boxSizing: "border-box"
                                            }}
                                        />
                                    </Box>
                                    <Divider />
                                    <Typography variant="h1" align="center" sx={{
                                        m: 0.5,
                                        color: "#1976d2",
                                        fontSize: { xs: 24, sm: 32, md: 40 }
                                    }}>
                                        <span style={{ fontSize: "20px" }}>{currencySymbol} </span>{Intl.NumberFormat('en-US').format(parseFloat(totaldailycharges()).toFixed(2))}
                                    </Typography>
                                    <Typography sx={{
                                        mt: -2,
                                        fontSize: { xs: 10, sm: 11, md: 12 },
                                        color: "#1976d2",
                                        m: 0.5
                                    }}>
                                        {formatYmdDashboardDate(dated_)}
                                    </Typography>
                                    <Divider />
                                    <Box sx={{ pl: 0.5, pr: 0.5 }}>
                                        <Box sx={{
                                            maxHeight: { xs: 150, sm: 200, md: 255 },
                                            overflowY: "auto",
                                            scrollbarWidth: "thin"
                                        }}>
                                            <List sx={{ width: '100%', maxWidth: 360, m: 0, p: 0.5 }}>
                                                {Class_ && Class_.map((list, index) =>
                                                    <Box key={index}>
                                                        <ListItem
                                                            sx={{ p: 0 }}
                                                            disableGutters
                                                            secondaryAction={
                                                                <Typography sx={{ fontWeight: "bold", fontSize: { xs: 12, sm: 14 } }}>
                                                                    {currencySymbol + " " + Intl.NumberFormat('en-US').format(parseFloat(dailycharges(list)).toFixed(0))}
                                                                </Typography>
                                                            }
                                                        >
                                                            <ListItemText
                                                                primary={list.classname}
                                                                secondary={
                                                                    <Typography component="small" sx={{ fontSize: { xs: 10, sm: 12 } }}>
                                                                        {formatYmdDashboardDate(dated_)}
                                                                    </Typography>
                                                                }
                                                            />
                                                        </ListItem>
                                                        <Divider />
                                                    </Box>
                                                )}
                                            </List>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </TabPanel>
                )}
                <TabPanel value={value} index={9} dir={theme.direction}>
                    <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12} sm={6} md={3}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#e9543c",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{ color: "white", fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                    Full Payment
                                </Typography>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 24, sm: 28, md: 32 },
                                    m: -1
                                }}>
                                    {currencySymbol} {Intl.NumberFormat('en-US').format(fullpayment())}
                                </Typography>
                                <Typography sx={{ color: "white", fontSize: { xs: 10, sm: 12, md: 14 } }}>
                                    {fullpaymentstud()} student(s)
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#27948f",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{ color: "white", fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                    Partial Payment
                                </Typography>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 24, sm: 28, md: 32 },
                                    m: -1
                                }}>
                                    {currencySymbol} {Intl.NumberFormat('en-US').format(partialpayment())}
                                </Typography>
                                <Typography sx={{ color: "white", fontSize: { xs: 10, sm: 12, md: 14 } }}>
                                    {partialpaymentstud()} student(s)
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#89358a",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{ color: "white", fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                    Outstanding Dept
                                </Typography>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 24, sm: 28, md: 32 },
                                    m: -1
                                }}>
                                    {currencySymbol} {Intl.NumberFormat('en-US').format(fullowing(students))}
                                </Typography>
                                <Typography sx={{ color: "white", fontSize: { xs: 10, sm: 12, md: 14 } }}>
                                    {fullowingstud()} student(s)
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 120, sm: 140, md: 150 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                bgcolor: "#31a0be",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{ color: "white", fontSize: { xs: 12, sm: 14, md: 16 } }}>
                                    Total Paid
                                </Typography>
                                <Typography variant="h1" align="center" sx={{
                                    color: "white",
                                    fontSize: { xs: 24, sm: 28, md: 32 },
                                    m: -1
                                }}>
                                    {currencySymbol} {Intl.NumberFormat('en-US').format(totalpaid())}
                                </Typography>
                                <Typography sx={{ color: "white", fontSize: { xs: 10, sm: 12, md: 14 } }}>
                                    {totalpaidstud()} student(s)
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box sx={{ my: { xs: 1, sm: 2 } }} />
                    <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={12} sm={7}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 200, sm: 250, md: 290 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{
                                    mb: -1,
                                    color: "gray",
                                    fontSize: { xs: 12, sm: 14, md: 16 }
                                }}>
                                    class and number students owing
                                </Typography>
                                <Studentchart3 classes={classlist} data={feesdata()} />
                            </Box>
                            <Box sx={{ my: { xs: 1, sm: 2 } }} />
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 200, sm: 250, md: 290 },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{
                                    mb: -1,
                                    color: "gray",
                                    fontSize: { xs: 12, sm: 14, md: 16 }
                                }}>
                                    class and number o students paid
                                </Typography>
                                <Studentchart3 classes={classlist} data={feesdata()} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <Box sx={{
                                borderRadius: "10px",
                                minHeight: { xs: 200, sm: 250, md: "97%" },
                                border: "solid",
                                borderColor: "lightgray",
                                borderWidth: "0.01px",
                                width: "100%",
                                m: { xs: 0.5, sm: 1 },
                                boxSizing: "border-box"
                            }}>
                                <Typography align="center" sx={{
                                    mb: -1,
                                    color: "gray",
                                    fontSize: { xs: 12, sm: 14, md: 16 }
                                }}>
                                    pie chart of owing against paid
                                </Typography>
                                <Typography variant="h1" align="center" sx={{ fontSize: { xs: 24, sm: 32, md: 40 } }}>
                                    100
                                </Typography>
                                <Typography sx={{ fontSize: { xs: 10, sm: 12, md: 14 } }}>total due</Typography>
                                <Typography sx={{ fontSize: { xs: 10, sm: 12, md: 14 } }}>total paid</Typography>
                                <Typography sx={{ fontSize: { xs: 10, sm: 12, md: 14 } }}>outstanding</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </TabPanel>
            </SwipeableViews>
        </Box>
    );
}

export default App;